export default __webpack_public_path__ + "img/missing_image.png";